import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router-dom'
import { List, useMediaQuery, useTheme } from '@mui/material'

import { AccountTabLinks } from '../../common'
import { useStyles } from './styles'
import { Button } from './button.component'
import { useAccount } from 'src/hooks'

const AccountMobileNavigation = () => {
  const [t] = useTranslation()
  const classes = useStyles()
  const [, setSearchParams] = useSearchParams()
  const theme = useTheme()
  const { data: account, isSuccess } = useAccount()
  const isLaptop = useMediaQuery(theme.breakpoints.down('laptop'))

  const hideBilling = isSuccess && account?.white_label?.billing_hidden

  const handleNavigate = (tab: string | null) => () => {
    tab ? setSearchParams({ tab }) : setSearchParams({})
  }
  return (
    <List className={classes.itemsWrapper} disablePadding>
      <Button
        primary={t('account-add-header-title.v')}
        handleNavigate={handleNavigate(isLaptop ? AccountTabLinks.profile : null)}
      />
      {!hideBilling && (
        <Button
          primary={t('edit-account-title-1.v')}
          handleNavigate={handleNavigate(AccountTabLinks.billing)}
        />
      )}
      <Button
        primary={t('account-users-header-title.v')}
        handleNavigate={handleNavigate(AccountTabLinks.users)}
      />
      <Button
        primary={t('account-settings-header-title.v')}
        handleNavigate={handleNavigate(AccountTabLinks.settings)}
      />
    </List>
  )
}
export { AccountMobileNavigation }
